module.exports = __webpack_public_path__ + "static/img/shipping.3bba70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipping.png
// module id = MVUO
// module chunks = 2